import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react"; 
import { openPopup } from "../../../store/popupSlice"
import { useDispatch } from "react-redux";

export default function BoltNeed({ data }) {
    const dispatch = useDispatch();
  const [activeIndex, setActiveIndex] = useState(0);
  return (
    <>
      <section className="bolt-need-area">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-9">
              <div className="bolt-need-head">
                <h2 className="heading center-heading">{data && data.titlePart1} <span className="gradiant-color">{data && data.titlePart2}</span> {data && data.titlePart3}</h2>
                <p className="sub-heading">{data && data.description}</p>
              </div>
            </div>

            {data.boxes && data.boxes.map((box, index) => (
              <div key={index} className="col-lg-6 col-md-6" onClick={() => setActiveIndex(index)}>
                <div className="bolt-need-box">
                  <div className="need-box-head">
                    <div>
                      <img src={box.image} alt="logo" className="img-responsive" loading="lazy" />
                    <h3>{box.title}</h3>
                    </div>
                    <small className={activeIndex === index ? "active" : " "}><FontAwesomeIcon icon={faArrowDown} /></small>
                  </div>
                  <div className={`need-box-foot ${activeIndex === index ? "active" : ""}`}>
                    <p>{box.para}</p>
                    <span onClick={() => dispatch(openPopup())}>{box.btn}</span>
                  </div>
                </div>
              </div>
            ))}

          </div>
        </div>
      </section>
    </>
  )
}
